import type { SorterResult } from "antd/lib/table/interface";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import type { UserLogEntity } from "src/app/features/UserLog/types/UserLogEntity";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "../../../../../components";
import {
    displayDateTimeValue,
    displayEnumValue,
} from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";

export const UserLogsTable: FC<ResourceTableProps<UserLogEntity>> = ({
    datasource,
    resource,
    onRowSelectionChange,
    onStateChanged,
    selectedRowKeys,
}) => {
    const { t } = useTranslation();

    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<UserLogEntity>): ExtendedColumnsType<UserLogEntity>[] => {
            return [
                {
                    title: t("user.log.form.username"),
                    dataIndex: "username",
                    key: "username",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "username" ? sortInfo.order : null,
                },
                {
                    title: t("user.log.form.revisionType"),
                    dataIndex: "revisionType",
                    key: "revisionType",
                    sorter: () => 0,
                    render: (value) => displayEnumValue(value, "revision-types"),
                },
                {
                    title: t("user.log.form.object"),
                    dataIndex: "object",
                    key: "object",
                    sorter: () => 0,
                },
                {
                    title: t("user.log.table.created"),
                    dataIndex: "created",
                    key: "created",
                    sorter: () => 0,
                    render: (value) => displayDateTimeValue(value),
                },
                {
                    title: t("user.log.table.changes"),
                    dataIndex: "changes",
                    key: "changes",
                    sorter: () => 0,
                },
            ];
        },
        [t],
    );

    return (
        (datasource && (
            <GenericTable<UserLogEntity>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="userLogs_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                resource={resource}
                selectedRowKeys={selectedRowKeys}
            />
        )) ||
        null
    );
};
